import { createAsyncThunk, createSlice, PayloadAction, unwrapResult } from '@reduxjs/toolkit';
import { RootState } from './store';
import http from '../utils/http';
import { Fact, DimensionReference } from './AfrSlice';
import { Reference, Part, PartDefinition } from './TaxonomyReferenceSlice'
import { Label, DimensionalConceptRef, Deprecation, Concept, ConceptRef } from './ConceptSlice'
import { ConceptNode, NetworkConceptsFilter, NetworkConceptsPayload, emptyNCPayload } from './AccountsSlice'


export interface TitleState {
    titleConcepts: ConceptNode[];
    status: 'idle' | 'loading' | 'failed';
}

const initialState: TitleState = {
    titleConcepts: [],
    status: "idle",
}

export const getTitleValue = function (titleId: string, titleConcepts: ConceptNode[] | null): string[] {
    if (titleConcepts != null) {
        var title: ConceptNode | undefined = titleConcepts.find(tc => tc.concept.id === titleId);
        if (title == undefined) {
            return [];
        } else {
            return title.concept.documentation.split(/<br\/>/g);
        }
    } else {
        return [];
    }
}

export const loadTitles = createAsyncThunk(
    "Taxonomy/GetAllAccounts",
    async (ncFilter: NetworkConceptsFilter): Promise<NetworkConceptsPayload> => {
        try {
            const result = await http<NetworkConceptsFilter, NetworkConceptsPayload>({
                path: `/taxonomy/getAllAccounts`,
                method: 'post',
                body: ncFilter
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return emptyNCPayload;
            }
        } catch (ex) {
            return emptyNCPayload;
        }
    });

export const titleSlice = createSlice({
    name: 'Title',
    initialState,
    reducers: {
        resetTitleState: (state:any, action:any) => {
            return initialState
        },
        setToSelectedTitle: (state: any, action: any) => {
            state.selectedTile = action.payload;
        },
    },
    extraReducers: (builder: any) => {
        builder
            .addCase(loadTitles.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(loadTitles.fulfilled, (state: any, action: any) => {
                state.status = "idle";
                state.titleConcepts = action.payload.resultTree;
            })
    },
});

export const { resetTitleState, setSelectedTitle } = titleSlice.actions;

export const getSelectedTitles = (state: RootState) => state.title ? state.title.titleConcepts : [];

export default titleSlice.reducer;